'use client';

import { useState } from 'react';

import { useActionHandler } from '@/hooks/useAction';
import * as Modal from '@/ui/Modal';

type ActionModalProps = Omit<
    Modal.ModalProps,
    'open' | 'defaultOpen' | 'onOpenChange'
> & {
    action: string;
};

export function ActionModal({ action, ...props }: ActionModalProps) {
    const [open, setOpen] = useState(false);

    useActionHandler(action, () => {
        setOpen(true);
    });

    return <Modal.Root {...props} open={open} onOpenChange={setOpen} />;
}
